<template>
  <div name="hres81x">
    <div class="hres81x-login" v-if="!flgLoginSuccess">
      <div class="form-horizontal">
        <div class="header">
          <div class="icon"><i class="fa fa-lock"></i></div>
          <div class="text">Please login to view your Payslip.</div>
        </div>
        <div class="form-group">
          <div class="col-xs-12">
            <input type="password" 
                   v-model="password" 
                   class="form-control" 
                   :class="{ 'input-error' : errors.has('password') }"
                   id="payslipPassword" 
                   placeholder="Password"
                   v-validate="'required'"
                   data-vv-value-path="password"
                   name="password"
                   :has-error="errors.has('password')"
                   @keyup.enter="hres81xLogin()" >
            <div class="text-error" v-show="errors.has('password')">{{errors.first('password')}}</div>
          </div>
        </div>
        <div class="form-group">
          <div class="col-xs-12">
            <button type="button" class="btn btn-default bg-color-skin" @click="hres81xLogin()">Login</button>
          </div>
        </div>
      </div>
    </div>
    <search-box-index v-if="flgLoginSuccess"
                      :receivedStore="receivedHres81xIndex"
                      searchBoxAlias="hres81x"
                      :currentUser="dash.currentUser"
                      :nowLang="dash.nowLang"
                      :labels="labels[dash.nowLang]"
                      :labelsHres81x="dash.hres81x[dash.nowLang]"
                      :msgError="index.msg_error"
                      :data="index"
                      :postHres81xPrint="postHres81xPrint"
                      :lastNumperiod="lastNumperiod"
                      :numperiod="numperiod"
                      :receivedHres81xNumperiod="receivedHres81xNumperiod"
                      :flgProcess="flgProcess" />
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import * as types from 'store/modules/hres81x/mutation-types'
import searchBoxIndex from 'components/hres81x/searchBoxIndex'
import { EncodeUtils } from 'assets/encode'

export default {
  name: 'hres81x',
  data () {
    return {
      dash: this.$parent.$parent.$parent,
      password: ''
    }
  },
  created () {
    this.receivedHres81xColumnsLabels()
  },
  computed: {
    ...mapGetters({
      labels: types.GET_HRES81X_LABELS,
      index: types.GET_HRES81X_INDEX,
      numperiod: types.GET_HRES81X_NUMPERIOD,
      lastNumperiod: types.GET_HRES81X_LAST_NUMPERIOD,
      flgProcess: types.GET_HRES81X_FLG_PROCESS,
      flgLoginSuccess: types.GET_HRES81X_FLG_LOGIN_SUCCESS
    })
  },
  mounted () {
    this.setFlgLoginSuccess(false)
  },
  watch: {
    password () {
      this.$validator.validate('password', this.password).catch(e => {})
      this.$nextTick(() => {
        this.errors.clear()
      })
    }
  },
  methods: {
    hres81xLogin () {
      this.$validator.validateAll().then(result => {
        if (result) {
          let sendParams = {
            p_codpswd: (this.password !== '') ? EncodeUtils.stdenc(this.password) : ''
          }
          this.postHres81xLogin({sendParams: sendParams})
        }
      })
    },
    ...mapMutations({
      setFlgLoginSuccess: types.SET_HRES81X_FLG_LOGIN_SUCCESS
    }),
    ...mapActions({
      receivedHres81xColumnsLabels: types.RECEIVED_COLUMNS_LABELS,
      receivedHres81xIndex: types.RECEIVED_HRES81X_INDEX,
      receivedHres81xNumperiod: types.RECEIVED_HRES81X_NUMPERIOD,
      postHres81xPrint: types.POST_HRES81X_PRINT,
      postHres81xLogin: types.POST_HRES81X_LOGIN
    })
  },
  components: {
    searchBoxIndex
  }
}
</script>

<style src="./style.scss" lang='scss'></style>


// WEBPACK FOOTER //
// component.vue?13fe3ca7